<template lang="pug">
//- TODO: очистка инпута
v-text-field(
  v-model="inputValue"
  v-bind="attrs"
  v-on="$listeners"
  v-mask="mask"
  :class=`{
    'app-input--hide-arrows': hideNumberArrows,
  }`
).app-input
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
export default {
  name: 'AppTextInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    hideNumberArrows: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    attrs() {
      const { $props, $attrs } = this;

      return {
        'background-color': 'redesignControlsBackground',
        'hide-details': 'auto',
        outlined: true,
        dense: true,
        ...$props,
        ...$attrs,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.app-input {
  &::v-deep .v-input__append-inner {
    margin-top: 0 !important;
    align-self: center;
  }
  &--hide-arrows {
    &::v-deep input::-webkit-outer-spin-button,
    &::v-deep input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }
}

::v-deep.v-input {
  &.theme--light {
    color: unset;
  }

  &--is-focused.v-text-field--outlined {
    & .v-input__control {
      & fieldset {
        border-color: currentColor !important;
      }
    }
  }
}
</style>
